<template>
  <card-modal :visible="visible" @close="close" :height="height" transition="zoom" ref="modal">
    <div class="customer-info-box" slot="body" :style="style">
      <h4 class="page-title">{{$t('page_title')}} [{{props_data.index + 1}}{{$t('person')}}]</h4>
      <h4 class="page-title-s">{{$t('page_title_s')}} [{{props_data.index + 1}}{{$t('person')}}]</h4>
      <div class="popup-contents-box">

        <div class="sub-contents-box">
          <div class="customer-info">
            <div class="flex">
              <p class="info-title">{{$t('name')}}</p>
              <p class="info-item">{{customer_info.name}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('sex')}}</p>
              <p class="info-item">{{sex_type[customer_info.sex]}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('age')}}</p>
              <p class="info-item">{{customer_info.age}}</p>
            </div>

            <!-- <div class="flex">
              <p class="info-title">郵便番号</p>
              <p class="info-item">{{customer_info.post}}</p>
            </div> -->

            <div class="flex">
              <p class="info-title">{{$t('email')}}</p>
              <p class="info-item">{{customer_info.email}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('address')}}</p>
              <p class="info-item">{{customer_info.address}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('tel')}}</p>
              <p class="info-item">{{customer_info.tel}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('job')}}</p>
              <p class="info-item">{{customer_info.occuoation}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('p_dext')}}</p>
              <p class="info-item">{{customer_info.prior_destination}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('n_dext')}}</p>
              <p class="info-item">{{customer_info.next_destination}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('nationality')}}</p>
              <p class="info-item">{{customer_info.nationality}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('passport_no')}}</p>
              <p class="info-item">{{customer_info.passport_no}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('check_in')}}</p>
              <p class="info-item">{{customer_info.check_in}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('check_out')}}</p>
              <p class="info-item">{{customer_info.check_out}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('room_name')}}</p>
              <p class="info-item">{{customer_info.room_name}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('other')}}</p>
              <p class="info-item other">{{customer_info.other}}</p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('passport_copy')}}</p>
              <p class="info-item"><img :src="customer_info.passport"></p>
            </div>

            <div class="flex">
              <p class="info-title">{{$t('face_photo')}}</p>
              <p class="info-item"><img :src="customer_info.facephoto"></p>
            </div>

          </div>

        </div>

      </div>
      <div class="btn-box">
        <input type="button" class="new-add" @click="cancel" :value="$t('back')" />
        <input type="button" class="new-add" @click="edit" :value="$t('edit')" v-if="props_data.type=='manage'"/>
      </div>
    </div>
  </card-modal>
</template>

<script>
import BaseModal from '@/lib/BasePopup';
export default {
  mixins: [BaseModal],
  name: 'CustomerInfo',
  // ===========================================================================
  // language
  // ===========================================================================
  language: {
    'ja': {
      'page_title': '宿泊者情報詳細',
      'page_title_s': '宿泊者情報詳細',
      'name': 'お名前',
      'sex': '性別',
      'age': '年齢',
      'post_no': '郵便番号',
      'email': 'email',
      'address': 'ご住所',
      'tel': '電話番号',
      'job': 'ご職業',
      'p_dext': '前泊地',
      'n_dext': '行先地',
      'nationality': '国籍',
      'passport_no': 'パスポート番号',
      'check_in': 'ご到着',
      'check_out': 'ご出発',
      'room_name': '客室名',
      'other': 'その他(合計宿泊人数)',
      'person': '人目',
      'back': '戻る',
      'edit': '編集',
      'registration': '登録',
      'sex1': '男',
      'sex2': '女',
      'passport_copy': 'パスポートのコピー',
      'fileup': 'ファイルを選択',
      'required_fields': 'は必ず入力してください。',
      'required_fields2': '日本国籍以外の方は、パスポート番号記載の上、パスポートのコピーをアップロードしてください。',
      'enter_err': '未入力の項目：',
      'enter_ok': '宿泊者情報を登録しました。',
      'face_photo': '顔写真',
    },
    'en': {
      'page_title': 'Guest information details',
      'page_title_s': 'Guest information',
      'name': 'Guest name\n客人姓名\n손님 이름',
      'sex': 'Sex\n性别\n섹스',
      'age': 'Age\n年龄\n나이',
      'post_no': 'Postal code',
      'email': 'email',
      'address': 'Address\n地址\n주소',
      'tel': 'Phone number\n电话号码\n전화 번호',
      'job': 'Occupation\n占用\n직업',
      'p_dext': 'Prior Destination\n预先目的地\n이전 목적지',
      'n_dext': 'Next Destination\n下一个目的地\n다음 목적지',
      'nationality': 'Nationality\n国籍\n국적',
      'passport_no': 'Passport No.',
      'check_in': 'Check-in.\n报到\n체크인',
      'check_out': 'Check-out.\n查看\n점검',
      'room_name': 'Room No.\n房间号\n객실 번호',
      'other': 'Other',
      'person': ' person',
      'back': 'back',
      'edit': 'edit',
      'registration': 'Register',
      'sex1': 'Male',
      'sex2': 'Female',
      'passport_copy': 'copy of passport\n护照复印件\n여권 사본',
      'fileup': 'Select file',
      'required_fields': ' is required fields.',
      'required_fields2': ' If you are not a Japanese national, you should upload your copy of your passport by posting your passport number.',
      'enter_err': 'Please enter ',
      'enter_ok': 'Registered guest information.',
      'face_photo': 'Face Photo',
    }
  },
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    props_data: null,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      width: 'calc(100vw - 84px)',
      height: 'calc(100% - 28px)',
      // sex_type: ['', this.$t('sex1'), this.$t('sex2')],
      // height: `calc(${this.props_data.height}px - 80px)`,

      customer_info: {},
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    sex_type () {
      return ['', this.$t('sex1'), this.$t('sex2')];
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    let ld = new this.$loader(this);
    ld._data_set({customer_id: this.props_data.list.id});
    ld._post_cb_f = this.data_get_cb;
    if (this.props_data.type === 'user') {
      ld._load_start('user_customer_info_get.php');
      this.$store.commit('loginInfo/set_lang', this.props_data.lodg_data.language);
    } else {
      ld._load_start('customer_info_get.php');
    }
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get_cb (res) {
      this.customer_info = res.data.customer_info;
    },
    cancel () {
      this.close();
    },
    edit () {
      this.cancel();
      this.props_data.cb(this.props_data.list, this.props_data.index);
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.customer-info-box {
  background-color: #fefefe;
  padding: 32px;
  .popup-contents-box {
    margin: 20px 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    // height: calc(100vh - 255px);
    height: calc(100% - 113px);
    .guide-p {
      height: 40px;
      overflow: auto;
    }
  }
  .sub-contents-box {
    margin-bottom: 0px;
    margin-right: 0px;
  }
  h4 {
    font-size: 18px;
    border-bottom: solid 1px #d3d4d8;
    width: 100%;
    padding: 0px 0px 5px 0px;
  }
  .page-title-s {
    display: none;
  }
  .new-add {
    color: #fefefe;
    display: block;
    text-align: center;
    padding: 8px 8px 8px 8px;
    font-size: 16px;
    text-decoration: none;
    border-radius: 3px;
    width: 150px;
    margin-left: 16px;
  }

  .customer-info {
    border-bottom: 1px solid #cecece;
  }

  .info-title {
    min-width: 180px;
    padding: 10px 13px 3px 3px;
    background: #fbfbfb;
    text-align: right;
    line-height: 1.5;
    border-top: 1px solid #d3d4d8;
    border-left: 1px solid #d3d4d8;
    color: #24273b;
    white-space: pre-wrap;
  }
  img {
    width: 100%;
  }
  .info-item {
    padding: 8px;
    flex: 1;
    line-height: 1.8;
    border-top: 1px solid #d3d4d8;
    border-left: 1px solid #d3d4d8;
    border-right: 1px solid #d3d4d8;
  }
  .other {
    word-break: break-all;
    white-space: pre-wrap;
  }
  .btn-box {
    display: flex;
  }
  @media (max-width: 767px) {
    .customer-info {
      border: initial;
    }
    .flex {
      display: block;
      border: initial;
    }
    .info-title {
      width: auto;
      padding: 3px;
      border: initial;
      text-align: left;
    }

    .info-item {
      padding: 5px;
      border: initial;
    }

    .new-add {
      width: 120px;
    }

    .page-title {
      display: none;
    }

    .page-title-s {
      display: inline-block;
    }
  }
}
</style>
